import { render } from "./UnsupportedBrowser.vue?vue&type=template&id=45875819&ts=true"
import script from "./UnsupportedBrowser.vue?vue&type=script&lang=ts"
export * from "./UnsupportedBrowser.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__